import type { Ref } from "react";
import type { ScrollViewProps, ScrollView as RNScrollView } from "react-native";

import ScrollView from "$src/core/components/atoms/ScrollView/ScrollView";

import $ from "./HorizontalSnapScrollView.styles";

type HorizontalSnapScrollViewProps = Omit<
  ScrollViewProps,
  | "horizontal"
  | "showsHorizontalScrollIndicator"
  | "snapToInterval"
  | "onLayout"
  | "ref"
> & {
  ref?: Ref<RNScrollView>;
  onLayout: ScrollViewProps["onLayout"];
  snapToInterval: number;
};

const HorizontalSnapScrollView = ({
  ref,
  onLayout,
  snapToInterval,
  contentContainerStyle,
  ...rest
}: HorizontalSnapScrollViewProps) => (
  <ScrollView
    accessibilityRole="list"
    horizontal
    ref={ref}
    showsHorizontalScrollIndicator={false}
    snapToInterval={snapToInterval}
    contentContainerStyle={[$.wrapperContent, contentContainerStyle]}
    style={$.wrapper}
    onLayout={onLayout}
    {...rest}
  />
);

export default HorizontalSnapScrollView;
